import { Box, Button, Checkbox, Container, FormControlLabel, FormGroup, Stack, TextField } from "@mui/material";
import MainLayout from "../../layouts/main-layout";
import { DataGrid, GridColDef, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { ChangeEvent, useEffect, useState } from "react";
import { faker } from '@faker-js/faker';


const TestDataGenerator = () => {

  const [noOfRandomData, setNoOfRandomData] = useState(25);
  const [testDataColumns, setTestDataColumns] = useState<GridColDef[]>([]);
  const [testDataRows, setTestDataRows] = useState<any[]>([]);
  const [dataOptions, setDataOptions] = useState({
    titleEN: true,
    firstNameEN: true,
    lastNameEN: true,
    fullNameEN: false,
    genderEN: false,
    dateOfBirthEN: false,
    age: false,
    email: true,
    phoneNo: false,
    citizenId: true,
  });

  useEffect(() => {
    generateTestData();
  }, []);

  const generateTestData = () => {
    console.log('Generate Test Data');

    let maxRandom = noOfRandomData;
    // Generate columns
    if(maxRandom > 999) {
      maxRandom = 999;
      setNoOfRandomData(maxRandom);
    }

    const dataColumns = [];
    if(dataOptions.titleEN) {
      dataColumns.push({ field: 'titleEN', headerName: 'Title', width: 60 });
    }
    if(dataOptions.firstNameEN) {
      dataColumns.push({ field: 'firstNameEN', headerName: 'First Name', width: 150 });
    }
    if(dataOptions.lastNameEN) {
      dataColumns.push({ field: 'lastNameEN', headerName: 'Last Name', width: 150 });
    }
    if(dataOptions.fullNameEN) {
      dataColumns.push({ field: 'fullNameEN', headerName: 'Full Name', width: 250 });
    }
    if(dataOptions.genderEN) {
      dataColumns.push({ field: 'genderEN', headerName: 'Gender', width: 120 });
    }
    if(dataOptions.dateOfBirthEN) {
      dataColumns.push({ field: 'dateOfBirthEN', headerName: 'Date Of Birth', width: 150 });
    }
    if(dataOptions.age) {
      dataColumns.push({ field: 'age', headerName: 'Age', width: 60 });
    }
    if(dataOptions.email) {
      dataColumns.push({ field: 'email', headerName: 'Email', width: 300 });
    }
    if(dataOptions.phoneNo) {
      dataColumns.push({ field: 'phoneNo', headerName: 'Phone no.', width: 120 });
    }
    if(dataOptions.citizenId) {
      dataColumns.push({ field: 'citizenId', headerName: 'Citizen Id', width: 200 });
    }
    setTestDataColumns(dataColumns);

    // Generate rows
    const dataRows = [];
    for(let i = 0; i < maxRandom; i++) {
      const dataRow: { [key: string]: any } = { id: i};
      const randomDOB = randomDateOfBirth();
      const randomAge = calculateAge(randomDOB);

      if(dataOptions.titleEN) {
        dataRow['titleEN'] = faker.person.prefix();
      }
      if(dataOptions.firstNameEN) {
        dataRow['firstNameEN'] = faker.person.firstName();
      }
      if(dataOptions.lastNameEN) {
        dataRow['lastNameEN'] = faker.person.lastName();
      }
      if(dataOptions.fullNameEN) {
        dataRow['fullNameEN'] = faker.person.fullName();
      }
      if(dataOptions.genderEN) {
        dataRow['genderEN'] = faker.person.sex()
      }
      if(dataOptions.dateOfBirthEN) {
        dataRow['dateOfBirthEN'] = randomDOB.toISOString().split('T')[0];
      }
      if(dataOptions.age) {
        dataRow['age'] = randomAge;
      }
      if(dataOptions.email) {
        dataRow['email'] = faker.internet.email().toLowerCase();
      }
      if(dataOptions.phoneNo) {
        dataRow['phoneNo'] = faker.helpers.replaceSymbolWithNumber('0##-###-####');
      }
      if(dataOptions.citizenId) {
        dataRow['citizenId'] = generateThaiCitizenID();
      }
      dataRows.push(dataRow);
    }
    setTestDataRows(dataRows);
  };

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setDataOptions(() => ({
      ...dataOptions,
      [name]: checked,
    }));
  };

  const handleNoOfRandomChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    let finalValue = parseInt(value);
    if(!finalValue) {
      finalValue = 0;
    }
    setNoOfRandomData(finalValue);
  };

  const customToolbar = function() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport/>
      </GridToolbarContainer>
    );
  }
  
  return (
    <MainLayout>
      <Box
        sx={{
          bgcolor: 'background.paper',
          pt: 12,
          pb: 6,
        }}
      >
        <Container maxWidth="lg">
          <h1 className="text-center">Data Generator</h1>
          <FormGroup>
            <Stack direction="row" spacing={2} sx={{pt: 4}}> 
              <FormControlLabel control={<Checkbox name='titleEN' checked={dataOptions.titleEN} onChange={handleCheckboxChange} />} label="Title" />
              <FormControlLabel control={<Checkbox name='firstNameEN' checked={dataOptions.firstNameEN} onChange={handleCheckboxChange} />} label="Firstname" />
              <FormControlLabel control={<Checkbox name='lastNameEN' checked={dataOptions.lastNameEN} onChange={handleCheckboxChange} />} label="Lastname" />
              <FormControlLabel control={<Checkbox name='fullNameEN' checked={dataOptions.fullNameEN} onChange={handleCheckboxChange} />} label="Fullname" />

              <FormControlLabel control={<Checkbox name='genderEN' checked={dataOptions.genderEN} onChange={handleCheckboxChange} />} label="Gender" />
              <FormControlLabel control={<Checkbox name='dateOfBirthEN' checked={dataOptions.dateOfBirthEN} onChange={handleCheckboxChange} />} label="Date of birth" />
              <FormControlLabel control={<Checkbox name='age' checked={dataOptions.age} onChange={handleCheckboxChange} />} label="Age" />            
            </Stack>
            <Stack direction="row" spacing={2} sx={{pb: 4}}>
              <FormControlLabel control={<Checkbox name='email' checked={dataOptions.email} onChange={handleCheckboxChange} />} label="Email" />
              <FormControlLabel control={<Checkbox name='phoneNo' checked={dataOptions.phoneNo} onChange={handleCheckboxChange} />} label="Phone No." />
              <FormControlLabel control={<Checkbox name='citizenId' checked={dataOptions.citizenId} onChange={handleCheckboxChange} />} label="Thai Citizen Id" />
            </Stack>
          </FormGroup>
          <FormGroup>
            <Stack direction="row" spacing={2} sx={{pb: 4}}>
              <TextField label="Records" variant="outlined" size="small" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*',   }} value={noOfRandomData} onChange={handleNoOfRandomChange}></TextField>
            </Stack>
          </FormGroup>
          
          <Button onClick={generateTestData} variant="contained" size="medium" type="submit">Generate</Button>
          
          <DataGrid
            sx={{mt: 4}}

            columns={testDataColumns}
            rows={testDataRows}
            
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[]}
            checkboxSelection={false}
            disableRowSelectionOnClick
            slots={{ toolbar: customToolbar }}
          />
        </Container>
      </Box>
    </MainLayout>
  );
};

function generateThaiCitizenID(): string {
  const getRandomDigit = () => Math.floor(Math.random() * 10);

  const d1 = getRandomDigit();
  const d2 = getRandomDigit();
  const d3 = getRandomDigit();
  const d4 = getRandomDigit();
  const d5 = getRandomDigit();
  const d6 = getRandomDigit();
  const d7 = getRandomDigit();
  const d8 = getRandomDigit();
  const d9 = getRandomDigit();
  const d10 = getRandomDigit();
  const d11 = getRandomDigit();
  const d12 = getRandomDigit();

  const n13 = 11 - (((d1 * 13) + (d2 * 12) + (d3 * 11) + (d4 * 10) + (d5 * 9) + (d6 * 8) + (d7 * 7) + (d8 * 6) + (d9 * 5) + (d10 * 4) + (d11 * 3) + (d12 * 2)) % 11);

  let d13: number;

  if (n13 === 10) {
    d13 = 0;
  } else if (n13 === 11) {
    d13 = 1;
  } else {
    d13 = n13;
  }

  return `${d1}${d2}${d3}${d4}${d5}${d6}${d7}${d8}${d9}${d10}${d11}${d12}${d13}`;
}

function randomDateOfBirth() {
  // Define the age range you want for the date of birth
  const minAge = 0; // Minimum age
  const maxAge = 99; // Maximum age
  const currentDate = new Date();
  const maxDOB = new Date(currentDate.getFullYear() - minAge, currentDate.getMonth(), currentDate.getDate());
  const minDOB = new Date(currentDate.getFullYear() - maxAge, currentDate.getMonth(), currentDate.getDate());

  // Generate a random date of birth within the specified range
  return faker.date.between({from: minDOB, to: maxDOB});
}

function calculateAge(dateOfBirth:Date) {
  const dob = new Date(dateOfBirth);
  const currentDate = new Date();
  
  // Calculate the difference in years
  let age = currentDate.getFullYear() - dob.getFullYear();

  // Check if the current date hasn't reached the birthdate yet this year
  if (currentDate.getMonth() < dob.getMonth() || (currentDate.getMonth() === dob.getMonth() && currentDate.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}


export default TestDataGenerator;